import z from 'zod'
import { parseWithZod } from '../utils'
import { auth } from './auth'
import { http } from './http'
import { FirmSchema, RedactedFirmSchema } from '../schemas'

export const FirmResponseSchema = z.object({
  firm: FirmSchema,
})

const FirmsResponseSchema = z.object({
  firms: z.array(FirmSchema),
})

const RedactedFirmsResponseSchema = z.object({
  firms: z.array(RedactedFirmSchema),
})

export const firms = {
  create: async (
    payload: {
      firm: {
        name: string
        abbreviation: string
        deal_id: string
        gas_is_public: boolean | null
        gas_group_ids?: number[] | null
      }
    },
    dealId: number,
  ) => {
    const regionHost = auth.getUserRegionHost()
    const result = await http.post(`${regionHost}/api/firms`, payload, dealId)
    const parsedResult = parseWithZod(FirmResponseSchema, result)
    return parsedResult.firm
  },

  edit: async (
    firmId: number,
    payload: {
      firm: {
        name: string
        abbreviation: string
        deal_id: string
        gas_is_public: boolean | null
        gas_group_ids?: number[] | null
      }
    },
    dealId: number,
  ) => {
    const regionHost = auth.getUserRegionHost()
    const result = await http.put(`${regionHost}/api/firms/${firmId}`, payload, dealId)
    const parsedResult = parseWithZod(FirmResponseSchema, result)
    return parsedResult.firm
  },

  getAll: async (dealId: number) => {
    const regionHost = auth.getUserRegionHost()
    const result = await http.get(`${regionHost}/api/deals/${dealId}/firms`)
    const parsedResult = parseWithZod(FirmsResponseSchema, result)
    return parsedResult.firms
  },

  getAllRedacted: async (dealId: number) => {
    const regionHost = auth.getUserRegionHost()
    const result = await http.get(`${regionHost}/api/deals/${dealId}/redacted_firms`)
    const parsedResult = parseWithZod(RedactedFirmsResponseSchema, result)
    return parsedResult.firms
  },

  updateAccess: async (
    firmId: number,
    payload: { gas_is_public: boolean | null; gas_group_ids?: number[] | null },
    dealId: number,
  ) => {
    const regionHost = auth.getUserRegionHost()
    const result = await http.post(
      `${regionHost}/api/firms/${firmId}/update_access`,
      payload,
      dealId,
    )
    const parsedResult = parseWithZod(FirmResponseSchema, result)
    return parsedResult.firm
  },

  delete: async (firmId: number, dealId: number) => {
    const regionHost = auth.getUserRegionHost()
    return await http.delete(`${regionHost}/api/firms/${firmId}`, dealId)
  },
}
